import { useState } from 'react';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, Typography } from '@mui/material';

const columns = [
    { id: 'id', label: 'Id', minWidth: 30 },
    { id: 'name', label: 'Task Name', minWidth: 120 },
    { id: 'taskValue', label: 'Task Value', minWidth: 120 },
    { id: 'code', label: 'Task Code', minWidth: 120 }
];

const TasklsitDataTable = ({ tasklist }) => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <>
            <Typography variant="h3" sx={{ mt: 3 }}>
                Task List
            </Typography>
            <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
                    <TableHead>
                        <TableRow>
                            {columns.map((c) => {
                                return (
                                    <TableCell key={c.id} align="left" style={{ minWidth: c.minWidth }}>
                                        {c.label}
                                    </TableCell>
                                );
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(tasklist === undefined ? [] : tasklist)
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            return (
                                <TableRow hover tabIndex={-1} key={row.id}>
                                    <TableCell>{row.id}</TableCell>
                                    <TableCell>{row.name}</TableCell>
                                    <TableCell>{row.taskValue}</TableCell>
                                    <TableCell>{row.code}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={tasklist === undefined ? 0 : tasklist.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
        </>
    );
};

export default TasklsitDataTable;
